<div class="modal-body pt-0" [formGroup]="languageForm">
  <div class="container px-5 pt-5 mt-md-3">
    <div class="row mb-3">
      <div class="col-12">
        <button (click)="logout()" class="btn btn-outline-success btn-lg bg-white go-back-btn" type="button">
          {{ backButtonTranslation | translate }}
        </button>
      </div>
    </div>
  </div>
  @if (initialSetup) {
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <h5 class="pb-4 required">{{ translationPrefix + ".languageChoice" | translate }}</h5>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-6">
        <div class="row text-start text-md-center mb-4">
          @for (item of ('common.langs' | translate | keyvalue); track item) {
          <div class="col-12 col-md-4 mb-3">
            <div class="form-check abc-radio abc-radio-success pl-0">
              <input
                formControlName="languagePicker"
                name="languagePicker"
                id="{{item.key}}"
                value="{{item.key}}"
                type="radio"
                class="form-check-input"
              />
              <label class="form-check-label" for="{{item.key}}"><b>{{ item.value["label"] }}</b></label>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="row pb-3 pb-md-2 justify-content-center">
      <div class="col-12 col-sm-3 d-flex justify-content-center">
        <button
          [disabled]="this.languagePicker?.value === null"
          [ngClass]="{
            'btn-secondary': !this.languagePicker?.value,
            'btn-success': this.languagePicker?.value,
          }"
          class="btn btn-block btn-success"
          (click)="submitSelection()"
        >
          {{ "wizard.actions.continue" | translate }}
        </button>
      </div>
    </div>
  </div>
  } @else {
  <div class="container py-4">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <h5 class="pb-4 required">{{ translationPrefix + ".languageChoice" | translate }}</h5>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-6">
        <div class="row text-start text-md-center mb-4">
          @for (item of ('common.langs' | translate | keyvalue); track item) {
          <div class="col-12 col-md-4 mb-3">
            <div class="form-check abc-radio abc-radio-success pl-0">
              <input
                formControlName="languagePicker"
                name="languagePicker"
                id="{{item.key}}"
                value="{{item.key}}"
                type="radio"
                class="form-check-input"
              />
              <label class="form-check-label" for="{{item.key}}"><b>{{ item.value["label"] }}</b></label>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
    <div class="row pb-3 pb-md-2 justify-content-center">
      <div class="col-12 col-sm-3 d-flex justify-content-center">
        <button
          [disabled]="this.languagePicker?.value === null"
          [ngClass]="{
          'btn-secondary': !this.languagePicker?.value,
          'btn-success': this.languagePicker?.value,
        }"
          class="btn btn-block btn-success"
          (click)="submitSelection()"
        >
          {{ "wizard.actions.continue" | translate }}
        </button>
      </div>
    </div>
  </div>
  }
</div>
